import React from 'react';

export const BackNavLinkContext = React.createContext(null);
export const BackNavRegistrationContext = React.createContext(null);
export const ControlsContext = React.createContext(null);
export const DropdownContext = React.createContext({});
export const HeaderContext = React.createContext(null);
export const PageLayoutContext = React.createContext(null);
export const RightButtonContext = React.createContext(null);
export const TitleContext = React.createContext(null);
